import { defineStore } from 'pinia'

import type { PaymentPoliciesStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const usePaymentPoliciesStore = defineStore('payment-policies', {
  state: (): PaymentPoliciesStore => ({
    loading: false,
    paginatedData: null,
    selectedDemoEla: null,
    selectedDemoMath: null,
    selectedPaidEla: null,
    selectedPaidMath: null,
    tutorPaymentPoliciesData: null,
    isModalConfirmPaymentPolicy: false,
    edits: [],
    selectedNames: {},
  }),
  actions,
  getters,
})
